import { CTAButton } from '@gamma/ui/buttons';
import { ErrorBoundary } from '@gamma/ui/overlay';
import {
  CardPageContent,
  CardPageCTA,
  CardPageHeading,
  CardPageIllustration,
  CardPageSubtitle,
} from '@gamma/ui/pages';
import { useNavigate } from 'react-router';
import { MFA } from '../../../../../shared/constants';
import { useUserSession } from '../../../../../shared/hooks';
import { i18n } from '../../../../../shared/localization';

interface IComplete {
  preferredMFA: string;
}

export const CompleteRegistration = ({ preferredMFA }: IComplete) => {
  const navigate = useNavigate();
  const { title, subtitle, subtitleAlt, cta } =
    i18n.pages.registration.complete;

  const { signOut } = useUserSession();

  const handleOnSignInClick = async () => {
    if (preferredMFA === MFA.NOMFA) {
      navigate('/', { replace: true });
    } else {
      signOut();
    }
  };

  return (
    <ErrorBoundary page="Registration Complete Page">
      <CardPageContent>
        <CardPageHeading>{title}</CardPageHeading>
        <CardPageIllustration illustration="Complete" />
        <CardPageSubtitle>
          {preferredMFA === MFA.NOMFA ? subtitleAlt : subtitle}
        </CardPageSubtitle>
      </CardPageContent>
      <CardPageCTA>
        <CTAButton onClick={handleOnSignInClick}>{cta}</CTAButton>
      </CardPageCTA>
    </ErrorBoundary>
  );
};
